import PresenceAPI from "../api/presence";

export const dashboards = {
    state: {
        dashboardPresences: [],
        dashboardPresencesOptions:{
            lineCount:0,
            breakfastCount:0,
            lunchCount:0,
            teaCount:0,
            entryCount:0,
            leaveCount:0,
            orderByPresent:'presences.leave',
            orderDirectionPresent:'desc',
            orderBy:'children.surname',
            orderDirection:'asc',
            itemsPerPage:20,
        },
        dashboardPresencesLoadStatus: 0,
    },

    actions: {
        loadDashboardPresences({ state, commit, dispatch }) {
            commit("setDashboardPresences", []);
            commit("setDashboardPresencesLoadStatus", 1);
                PresenceAPI.getDashboardPresent({
                    offset:0,
                    itemsPerPage:state.dashboardPresencesOptions.itemsPerPage, 
                    orderBy:state.dashboardPresencesOptions.orderByPresent,
                    orderDirection:state.dashboardPresencesOptions.orderDirectionPresent,
                })
                .then(function(response) {
                    commit("setDashboardPresenceLineCount", response.data.counters);
                    commit("setDashboardPresences", response.data.presences);
                    dispatch("applyIndexOnDashboardPresences");
                    commit("setDashboardPresencesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setDashboardPresences", []);
                    commit("setDashboardPresencesLoadStatus", 3);
                });
         
        },
        loadMoreDashboardPresences({ state, commit, dispatch }) {
            commit("setDashboardPresencesLoadStatus", 1);
                PresenceAPI.getDashboardPresent({
                    offset:state.dashboardPresences.length,
                    itemsPerPage:state.dashboardPresencesOptions.itemsPerPage, 
                    orderBy:state.dashboardPresencesOptions.orderByPresent,
                    orderDirection:state.dashboardPresencesOptions.orderDirectionPresent,
                })
                .then(function(response) {
                    commit("setDashboardPresenceLineCount", response.data.counters);
                    commit("setDashboardPresences", _.concat(state.dashboardPresences, response.data.presences));
                    dispatch("applyIndexOnDashboardPresences");
                    commit("setDashboardPresencesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setDashboardPresences", []);
                    commit("setDashboardPresencesLoadStatus", 3);
                });
         
        },

        loadDashboardAbsent({ state, commit, dispatch }) {
            commit("setDashboardPresences", []);
            commit("setDashboardPresencesLoadStatus", 1);
                PresenceAPI.getDashboardAbsent({
                    offset:0,
                    itemsPerPage:state.dashboardPresencesOptions.itemsPerPage, 
                    orderBy:state.dashboardPresencesOptions.orderBy,
                    orderDirection:state.dashboardPresencesOptions.orderDirection,
                })
                .then(function(response) {
                    commit("setDashboardPresenceLineCount", response.data.counters);
                    commit("setDashboardPresences", response.data.presences);
                    dispatch("applyIndexOnDashboardPresences");
                    commit("setDashboardPresencesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setDashboardPresences", []);
                    commit("setDashboardPresencesLoadStatus", 3);
                });
         
        },
        loadMoreDashboardAbsent({ state, commit, dispatch }) {
            commit("setDashboardPresencesLoadStatus", 1);
                PresenceAPI.getDashboardAbsent({
                    offset:state.dashboardPresences.length,
                    itemsPerPage:state.dashboardPresencesOptions.itemsPerPage, 
                    orderBy:state.dashboardPresencesOptions.orderBy,
                    orderDirection:state.dashboardPresencesOptions.orderDirection,
                })
                .then(function(response) {
                    commit("setDashboardPresenceLineCount", response.data.counters);
                    commit("setDashboardPresences", _.concat(state.dashboardPresences, response.data.presences));
                    dispatch("applyIndexOnDashboardPresences");
                    commit("setDashboardPresencesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setDashboardPresences", []);
                    commit("setDashboardPresencesLoadStatus", 3);
                });
         
        },

        loadDashboardNoStatus({ state, commit, dispatch }) {
            commit("setDashboardPresences", []);
            commit("setDashboardPresencesLoadStatus", 1);
                PresenceAPI.getDashboardNoStatus({
                    offset:0,
                    itemsPerPage:state.dashboardPresencesOptions.itemsPerPage, 
                    orderBy:state.dashboardPresencesOptions.orderBy,
                    orderDirection:state.dashboardPresencesOptions.orderDirection,
                })
                .then(function(response) {
                    commit("setDashboardPresenceLineCount", response.data.counters);
                    commit("setDashboardPresences", response.data.presences);
                    dispatch("applyIndexOnDashboardPresences");
                    commit("setDashboardPresencesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setDashboardPresences", []);
                    commit("setDashboardPresencesLoadStatus", 3);
                });
         
        },
        loadMoreDashboardNoStatus({ state, commit, dispatch }) {
            commit("setDashboardPresencesLoadStatus", 1);
                PresenceAPI.getDashboardNoStatus({
                    offset:state.dashboardPresences.length,
                    itemsPerPage:state.dashboardPresencesOptions.itemsPerPage, 
                    orderBy:state.dashboardPresencesOptions.orderBy,
                    orderDirection:state.dashboardPresencesOptions.orderDirection,
                })
                .then(function(response) {
                    commit("setDashboardPresenceLineCount", response.data.counters);
                    commit("setDashboardPresences", _.concat(state.dashboardPresences, response.data.presences));
                    dispatch("applyIndexOnDashboardPresences");
                    commit("setDashboardPresencesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setDashboardPresences", []);
                    commit("setDashboardPresencesLoadStatus", 3);
                });
         
        },

        loadDashboardLate({ state, commit, dispatch }) {
            commit("setDashboardPresences", []);
            commit("setDashboardPresencesLoadStatus", 1);
                PresenceAPI.getDashboardLate({
                    offset:0,
                    itemsPerPage:state.dashboardPresencesOptions.itemsPerPage, 
                    orderBy:state.dashboardPresencesOptions.orderBy,
                    orderDirection:state.dashboardPresencesOptions.orderDirection,
                })
                .then(function(response) {
                    commit("setDashboardPresenceLineCount", response.data.counters);
                    commit("setDashboardPresences", response.data.presences);
                    dispatch("applyIndexOnDashboardPresences");
                    commit("setDashboardPresencesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setDashboardPresences", []);
                    commit("setDashboardPresencesLoadStatus", 3);
                });
         
        },
        loadMoreDashboardLate({ state, commit, dispatch }) {
            commit("setDashboardPresencesLoadStatus", 1);
                PresenceAPI.getDashboardLate({
                    offset:state.dashboardPresences.length,
                    itemsPerPage:state.dashboardPresencesOptions.itemsPerPage, 
                    orderBy:state.dashboardPresencesOptions.orderBy,
                    orderDirection:state.dashboardPresencesOptions.orderDirection,
                })
                .then(function(response) {
                    commit("setDashboardPresenceLineCount", response.data.counters);
                    commit("setDashboardPresences", _.concat(state.dashboardPresences, response.data.presences));
                    dispatch("applyIndexOnDashboardPresences");
                    commit("setDashboardPresencesLoadStatus", 2);
                })
                .catch(function() {
                    commit("setDashboardPresences", []);
                    commit("setDashboardPresencesLoadStatus", 3);
                });
         
        },
        
        setDashboardPresenceOptions({ state, commit, dispatch },data){
            commit("setDashboardPresenceOptions",data.options);
            
            dispatch("loadDashboardPresences");
        },
        setDashboardAbsentOptions({ state, commit, dispatch },data){
            commit("setDashboardPresenceOptions",data.options);
            
            dispatch("loadDashboardAbsent");
        },
        setDashboardNoStatusOptions({ state, commit, dispatch },data){
            commit("setDashboardPresenceOptions",data.options);
            
            dispatch("loadDashboardNoStatus");
        },
        setDashboardLateOptions({ state, commit, dispatch },data){
            commit("setDashboardPresenceOptions",data.options);
            
            dispatch("loadDashboardLate");
        },
        applyIndexOnDashboardPresences({ commit, state, dispatch }) {
            let localDashboardPresences = state.dashboardPresences;

            var i = 1;
            localDashboardPresences.forEach(p => {
                p.present = p.present?true:false;
                p.tea = p.tea?true:false;
                p.breakfast = p.breakfast?true:false;
                p.lunch = p.lunch?true:false;
                p.lp = i;
                i++;
            });

            commit("setDashboardPresences",localDashboardPresences);
        },
    },
    mutations: {
        setDashboardPresenceOptions(state,options){
            state.dashboardPresencesOptions = options;
        },
        setDashboardPresencesLoadStatus(state, status) {
            state.dashboardPresencesLoadStatus = status;
        },
        setDashboardPresences(state, rates) {
            state.dashboardPresences = rates;
        },
        setDashboardPresenceLineCount(state, counters) {
            state.dashboardPresencesOptions.lineCount = counters.present;
            state.dashboardPresencesOptions.breakfastCount = counters.breakfast;
            state.dashboardPresencesOptions.lunchCount = counters.lunch;
            state.dashboardPresencesOptions.teaCount = counters.tea;
            state.dashboardPresencesOptions.entryCount = counters.entry;
            state.dashboardPresencesOptions.leaveCount = counters.leave;
        },
    },

    getters: {
        getDashboardPresenceOptions(state){
            return state.dashboardPresencesOptions;
        },
        getDashboardPresencesLoadStatus(state) {
            return state.dashboardPresencesLoadStatus;
        },
        getDashboardPresences(state) {
            return state.dashboardPresences;
        },
    },
};
